import OrganizationPermission from './OrganizationPermission';
import OrganizationPermissionPasswordPolicy from './OrganizationPermissionPasswordPolicy';
import type { IOrganizationPermissions } from './OrganizationPermissions.interface';

export default class OrganizationPermissions implements IOrganizationPermissions {
  passwordPolicy: OrganizationPermissionPasswordPolicy;
  usersCanEditDeals: boolean;
  usersCanMoveDeals: boolean;
  usersCanExportData: boolean;
  usersCanSeeCommissionSplits: boolean;
  visibilityDashboard: OrganizationPermission;
  visibilityDeals: OrganizationPermission;
  visibilityTasks: OrganizationPermission;
  visibilityContacts: OrganizationPermission;
  visibilityOtherUsers: OrganizationPermission;
  visibilityFilters: OrganizationPermission;

  static build = (data: IOrganizationPermissions) => new OrganizationPermissions(data);
  static blank = () => new OrganizationPermissions();

  /**
   * Constructor
   * @param {IOrganizationPermissions} data
   */
  constructor(data?: IOrganizationPermissions) {
    this.passwordPolicy = new OrganizationPermissionPasswordPolicy(data?.passwordPolicy);
    this.usersCanEditDeals = data?.usersCanEditDeals === true;
    this.usersCanMoveDeals = data?.usersCanMoveDeals === true;
    this.usersCanExportData = data?.usersCanExportData === true;
    this.usersCanSeeCommissionSplits = data?.usersCanSeeCommissionSplits === true;
    this.visibilityDashboard = new OrganizationPermission(data?.visibilityDashboard);
    this.visibilityDeals = new OrganizationPermission(data?.visibilityDeals);
    this.visibilityTasks = new OrganizationPermission(data?.visibilityTasks);
    this.visibilityContacts = new OrganizationPermission(data?.visibilityContacts);
    this.visibilityOtherUsers = new OrganizationPermission(data?.visibilityOtherUsers);
    this.visibilityFilters = new OrganizationPermission(data?.visibilityFilters);
  }
}
